import { useAxiosAuth } from '@/hooks/useAxiosAuth.ts';
import { ApiConfig } from '@/config/api.config.ts';
import { GetHotelListItemDtoListResponseDto } from '@/features/hotels/types/hotels-dto.ts';

export const useDefaultTenantHotel = () => {
    const axiosInstance = useAxiosAuth();

    const getDefaultHotel = async () => {
        const url = ApiConfig.queries.features.hotels.endpoints.list;
        const response = await axiosInstance.get<GetHotelListItemDtoListResponseDto>(url);
        if (response.status !== 200 || !response.data.items) {
            return undefined;
        }

        if (response.data.items.length === 0) {
            return undefined;
        }

        // Assuming the first hotel is the default tenant hotel
        return {
            ...response.data.items[0],
            primaryColor: response.data.primaryColor,
            darkMode: response.data.darkMode,
            multiCurrency: response.data.multiCurrency,
            ordersEnabled: response.data.ordersEnabled ?? true,
            calendarCurrency: response.data.calendarCurrency,
            financePropertyCurrency: response.data.financePropertyCurrency,
            financeServicesCurrency: response.data.financeServicesCurrency,
            financeOtherCurrency: response.data.financeOtherCurrency,
        };
    };

    return {
        getDefaultHotel,
    };
};
